import axios from "axios";

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "/api";

const instance = axios.create({
  baseURL: API_BASE_URL,
});

// Automatisch Token an jede Anfrage anhängen
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;
